<div class="hunt-package">
  <kendo-card width="100%">
    <kendo-card-header class="k-hstack">
      <div class="row">
        <div class="col-lg-2">
          <hyperkit-typography variant="label1" align="left" color="inactive">Hunt Package</hyperkit-typography>
        </div>
        <div class="col-lg-12">
          <package-header>
            <header-title>
              <cyborg-trial-lock-unlock
                [huntPackage]="data"
              ></cyborg-trial-lock-unlock>
            </header-title>
            <header-options>
              <severity class="{{ data.severity | lowercase }}"
                >{{ data.severity }}
              </severity>
              <i
                *ngIf="favorited"
                class="k-icon k-font-icon k-i-bookmark favorite k-color-primary"
                (click)="unfavorite()"
              ></i>
              <i
                *ngIf="!favorited"
                class="k-icon k-font-icon k-i-bookmark-outline favorite k-color-primary"
                (click)="favorite()"
              ></i>
              <div class="options">
                <span *ngIf="huntModuleAccess; else noAccess">
                  <span *ngIf="huntCompatible">
                    <kendo-dropdownbutton
                      style="padding-left: 10px"
                      themeColor="primary"
                      [data]="options"
                      textField="actionName"
                      icon="chevron-down"
                    >
                      Hunt
                    </kendo-dropdownbutton>
                  </span>
                </span>
                <ng-template #noAccess>
                  <cyborg-button
                    color="outline"
                    size="medium"
                    (click)="openHuntDialog()"
                  >
                    <img
                      style="margin-right: 5px"
                      width="16"
                      height="16"
                      src="/assets/img/icons/cyborg-premium.png"
                    />
                    Hunt
                  </cyborg-button>
                </ng-template>
              </div>
            </header-options>
          </package-header>
<!-- 
          <hyperkit-typography variant="label1" align="left" color="inactive">Collection</hyperkit-typography>
          <hyperkit-typography variant="h5" align="left" color="primary">{{ data.collection.title }}</hyperkit-typography>
    
          <div class="collection-meta">
            <div class="date">
              <hyperkit-badge variant="neutral" text="Created">
              </hyperkit-badge>
              <hyperkit-typography variant="label1" align="left" color="primary">{{ data.collection.created_date | date : 'longDate' }}</hyperkit-typography>
            </div>
            <div class="date">
              <hyperkit-badge variant="neutral" text="Updated">
              </hyperkit-badge>
              <hyperkit-typography variant="label1" align="left" color="primary">{{ data.collection.last_updated | date : 'longDate' }}</hyperkit-typography>
            </div>
          </div> -->
          <package-description>
            <hyperkit-typography variant="label1" align="left" color="primary">{{ data.description }}</hyperkit-typography>
            <ul>
              <li>
                <div class="date">
                  <hyperkit-badge variant="neutral" text="Created">
                  </hyperkit-badge>
                  <hyperkit-typography variant="label1" align="left" color="primary">{{ data.created_date | date : 'longDate' }}</hyperkit-typography>
                </div>
              </li>
              <li>
                <span>Updated</span>
                <p>
                  {{ data.last_updated | date : 'longDate' }}
                </p>
              </li>
              <li *ngIf="data.context.threat_categories.length > 0">
                <span>Threat Category</span>
                <p>{{ data.context.threat_categories.join(', ') }}</p>
              </li>
              <li *ngIf="data.context.target_industries.length > 0">
                <span>Industry</span>
                <p>{{ data.context.target_industries.join(', ') }}</p>
              </li>
              <li *ngIf="data.mapping.kill_chains.length > 0">
                <span>Kill Chain</span>
                <p>{{ data.mapping.kill_chains }}</p>
              </li>
              <li *ngIf="data.mapping.mitre.mitre_attack_techniques.length > 0">
                <span>MITRE TECHNIQUES</span>
                <p>
                  {{ data.mapping.mitre.mitre_attack_techniques.join(', ') }}
                </p>
              </li>
              <li *ngIf="data.mapping.mitre.mitre_attack_tactics.length > 0">
                <span>MITRE TACTICS</span>
                <p>
                  {{ data?.mapping?.mitre?.mitre_attack_tactics.join(', ') }}
                </p>
              </li>
              <li *ngIf="data.context.threat_names.length > 0">
                <span>Threat Names</span>
                <p>{{ data.context.threat_names.join(', ') }}</p>
              </li>
              <li *ngIf="data.dependencies.length > 0">
                <span>Dependencies</span>
                <p>{{ data?.dependencies.join(', ') }}</p>
              </li>
            </ul>
            <div *ngIf="tags.length > 0">
              <cyborg-facet-buttons
                class="tile-facets"
                [facets]="tags"
                [groupByCategory]="false"
              ></cyborg-facet-buttons>
            </div>
          </package-description>
        </div>
      </div>
    </kendo-card-header>
  </kendo-card>
</div>
